export default __webpack_public_path__ + "static/media/img1.f4288323.png";